module.exports = __webpack_public_path__ + "img/trash-icon.10ed2fd2.svg";